import type {Icon} from '@primer/octicons-react'

import {CustomIcon} from './CustomIcon'

export const JetBrainsIcon: Icon = props => {
  return (
    <CustomIcon {...props}>
      <path
        fillRule="evenodd"
        d="M1.56341 15.9977H8.6715V16c.89305 0 1.7338-.3499 2.3701-.9815l3.9767-3.9762c.6249-.6248.9817-1.4882.9817-2.36977V1.56319C16 .699801 15.2978 0 14.4366 0H7.32624c-.89079 0-1.73385.349902-2.36786.981541L.981678 4.95541C.356768 5.58023 0 6.44363 0 7.32519v7.10931c0 .8634.702174 1.5632 1.56341 1.5632M2.6419 4.34286l2.83913-2.83874c.4954-.49304 1.14985-.763421 1.84521-.763421h7.11036c.4545 0 .8226.370351.8226.822491v7.10934c0 .68617-.2772 1.35867-.7635 1.84497l-2.8386 2.8381V4.34286zm-.12761.12759v9.01525H11.527l-1.008 1.0079c-.4931.4908-1.14988.7634-1.84524.7634H1.56341c-.45448 0-.822605-.3703-.822605-.8225V7.32519c0-.68617.277235-1.3587.763525-1.84494zm5.02857 6.95815H3.65714v.9143h3.88572z"
        clipRule="evenodd"
      />
    </CustomIcon>
  )
}
